import React, { useState, useEffect } from 'react';
import { ChromePicker } from 'react-color';
import { QRCodeCanvas } from 'qrcode.react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload, faDownload } from '@fortawesome/free-solid-svg-icons';

const QrCodeGenerator= () => {
  const [text, setText] = useState();
  const [background, setBackground] = useState('#fff');
  const [foreground, setForeground] = useState('#000');
  const [qrcodeSize, setQrcodeSize] = useState(200);
  const [qrImageSize, setQrImageSize] = useState(50);
  const [selectedImage, setSelectedImage] = useState(null);
  const [key, setKey] = useState(0);

  useEffect(() => {
    // Update the key whenever relevant state changes
    setKey((prevKey) => prevKey + 1);
  }, [text, background, foreground, qrcodeSize, qrImageSize, selectedImage]);

  const handleDownload = () => {
    const canvas = document.querySelector('canvas');
    const image = canvas.toDataURL('image/png');
    const link = document.createElement('a');
    link.href = image;
    link.download = 'qrcode.png';
    link.click();
  };
  const handleChangeqrImageSize = (event) => {
    setQrImageSize(event.target.value);
  };

  const handleChangeqrCodeSize = (event) => {
    setQrcodeSize(event.target.value);
  };

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file && file.type.includes('image')) {
      setSelectedImage(URL.createObjectURL(file));
    } else {
      setSelectedImage(null);
    }
  };

  const renderQRImage = () => {
    return <QRCodeCanvas
    key={key}
    value={text}
    size={qrcodeSize}
    bgColor={background}
    fgColor={foreground}
    level={`L`}
    includeMargin={false}
    imageSettings={{
      src: selectedImage,
      x: undefined,
      y: undefined,
      height: qrImageSize,
      width: qrImageSize,
      excavate: true,
    }}
  />
  }

  return (
    <div className="grid grid-cols-1 my-4 xl:grid-cols-2 xl:gap-4">
      <div className="col-span-2 xl:col-auto">
        <div className="h-full p-4 mb-4 space-y-6 bg-white border border-gray-200 rounded-lg shadow-sm 2xl:col-span-2 dark:border-gray-700 sm:p-6 dark:bg-gray-800">
          <div className="px-4 py-2 text-gray-400 border border-gray-200 border-dashed rounded dark:border-gray-600">
            <h3 className='uppercase border-l-4 border-blue-600 p-2'>Data Input</h3>
          </div>
          <div className="px-4 py-2 text-gray-400 rounded dark:border-gray-600">
            <button
              className="text-white mt-4 bg-blue-500 hover:bg-blue-700 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center me-2 mb-2"
              onClick={() => document.querySelector('input[type="file"]').click()}
            >
              <FontAwesomeIcon
                style={{ width: '18px' }}
                icon={faUpload}
              />
              {` `}&nbsp; Browse your Logo
            </button>
            <br/><br/>
            <input
              type="text"
              value={text}
              onChange={(event) => setText(event.target.value)}
              placeholder="Enter text"
              className="bg-gray-50 mb-4 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            />
            <br/>
            <input
              type="file"
              accept="image/*"
              onChange={handleImageUpload}
              className='hidden'
            />
            <label
              htmlFor="input"
              className="block text-sm text-gray-700 dark:text-white font-bold">
              {`Image Size: `} {qrImageSize}
            </label>
            <br/>
            <input
              type="range"
              min={10}
              max={300}
              value={qrImageSize}
              onChange={handleChangeqrImageSize}
              className='w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer dark:bg-gray-700'
            />
            <br/>
            <label
              htmlFor="input"
              className="block text-sm text-gray-700 dark:text-white font-bold">
              {`QR Code Size: `} {qrcodeSize}
            </label>
            <br/>
            <input
              type="range"
              min={50}
              max={500}
              value={qrcodeSize}
              onChange={handleChangeqrCodeSize}
              className='w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer dark:bg-gray-700'
            />
            <br/>
            <label
              htmlFor="input"
              className="block text-sm text-gray-700 dark:text-white font-bold">
              Backgound
            </label>
            <br/>
            <ChromePicker
              color={background}
              onChange={(color) => setBackground(color.hex)}
            />
            <br />
            <label
              htmlFor="input"
              className="block text-sm text-gray-700 dark:text-white font-bold">
              Foreground
            </label>
            <br />
            <ChromePicker
              color={foreground}
              onChange={(color) => setForeground(color.hex)}
            />
          </div>
        </div>
      </div>
      <div className="col-span-2 xl:col-auto">
        <div className="h-full p-4 mb-4 space-y-6 bg-white border border-gray-200 rounded-lg shadow-sm 2xl:col-span-2 dark:border-gray-700 sm:p-6 dark:bg-gray-800">
          <div className="px-4 py-2 text-gray-400 border border-gray-200 border-dashed rounded dark:border-gray-600">
            <h3 className='uppercase border-l-4 border-yellow-600 p-2'>QR Code Preview</h3>
          </div>
          <div className="px-4 py-2 text-gray-400  rounded dark:border-gray-600">
            <div>{renderQRImage()}</div>
          </div>
          <div className="px-4 py-2 text-gray-400 rounded dark:border-gray-600">
            <button
              className="text-white mt-4 bg-blue-500 hover:bg-blue-700 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center me-2 mb-2"
              onClick={handleDownload}
            >
              <FontAwesomeIcon
                style={{ width: '18px' }}
                icon={faDownload}
              />
              {` `}&nbsp; Download QR Code
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QrCodeGenerator;
